<ng-container *ngIf="!isPublicRoute">

  <app-topbar></app-topbar>
  <div class="app-layout" [ngClass]="{ 'navbar-contracted': checkIsCollapsed }">
    <app-navbar class="app-navbar" (isCollapsedEvent)="changeCheck($event)"></app-navbar>

    <app-alert class="fixed-alert" [text]="alertData.text" [type]="alertData.type" [duration]="alertData.duration!"
      *ngIf="alertData" (closeAlertEvent)="onCloseAlert()"></app-alert>

    <div class="app-content">
      <app-spinner></app-spinner>
      <!-- Contenido oculto hasta validar la cuenta (evita el flash del marketplace a conductores) -->
      <router-outlet *ngIf="isMsalInitialized"></router-outlet>
    </div>
  </div>

</ng-container>

<ng-container *ngIf="isPublicRoute">
  <app-spinner></app-spinner>
  <app-alert class="fixed-alert" [text]="alertData.text" [type]="alertData.type" [duration]="alertData.duration!"
    *ngIf="alertData" (closeAlertEvent)="onCloseAlert()"></app-alert>
  <router-outlet></router-outlet>
</ng-container>